import { ErrorMessage } from "@nju/form";
import { Icon } from "@nju/icons";
import { Separator, SideBox, Text } from "@nju/ui";
import { formatPrice } from "@nju/utils";

interface ISidebarAdditionalPackagePaymentProps {
  userFunds: number | undefined;
  hasNoFunds: boolean;
  productOfferPrice: number;
  testId?: string;
  type: "internationalCalls" | "roaming" | "packageGb";
}

export function SidebarAdditionalPackagePayment({
  productOfferPrice,
  hasNoFunds,
  userFunds,
  type,
  testId,
}: ISidebarAdditionalPackagePaymentProps) {
  return (
    <SideBox isExpandable={false} testId={testId} title="opłaty">
      <Separator size="xxs" tone="invisible" />
      <div className="flex justify-between">
        <Text>opłata jednorazowa:</Text>
        <Text align="right">
          {productOfferPrice && formatPrice(productOfferPrice)} zł
        </Text>
      </div>
      {!hasNoFunds && (type === "roaming" || type === "internationalCalls") && (
        <>
          <Separator size="s" thickness="medium" />
          <Text>Usługa zostanie włączona po potwierdzeniu płatności.</Text>
        </>
      )}
      {hasNoFunds && (
        <>
          <Separator size="s" thickness="medium" />
          <div className="flex justify-between">
            <div>
              <Icon height={24} name="wallet" tone="accent" width={24} />
              <Text className="pl-5">Twoje środki:</Text>
            </div>
            <div>
              <Text tone={hasNoFunds ? `alert` : `neutral`}>
                {userFunds && formatPrice(userFunds)} zł
              </Text>
            </div>
          </div>
          <Separator size="s" tone="invisible" />
          <ErrorMessage
            iconAlign="start"
            message="Nie masz wystarczającej ilości środków. Dodaj je, by włączyć pakiet."
            withIcon={true}
          />
          <Separator size="s" thickness="medium" />
          <Text>Usługa zostanie włączona po potwierdzeniu płatności.</Text>
        </>
      )}
    </SideBox>
  );
}
